const NPSQuestionnaireThirdStep = ({ feedback, setFeedback, handleBackBtn, handleSubmit }) => {
    return (
        <>
            <div className="content-wrapper">
                <div className="middle-content-wrapper">
                    <div className="text-content">
                        <p className="text-center">Would you like to add any comments or suggestions?</p>

                        <div className="middle-content-wrapper">
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <textarea
                                        value={feedback}
                                        onChange={(e) => setFeedback(e.target.value)}
                                        rows="4"
                                        className="feedback-textarea w-100"
                                    />
                                </div>

                                <div className="button-group">
                                    <button type="button" onClick={handleBackBtn} className="back-button">Back</button>
                                    <button type="submit" className="submit-button">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NPSQuestionnaireThirdStep